module.exports = __webpack_public_path__ + "static/media/Food2.cd08a88a.jpg";